/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A single trivia question
 * @export
 * @interface TriviaQuestion
 */
export interface TriviaQuestion {
    /**
     * 
     * @type {string}
     * @memberof TriviaQuestion
     */
    question: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TriviaQuestion
     */
    options: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof TriviaQuestion
     */
    correctIndex: number;
}

/**
 * Check if a given object implements the TriviaQuestion interface.
 */
export function instanceOfTriviaQuestion(value: object): value is TriviaQuestion {
    if (!('question' in value) || value['question'] === undefined) return false;
    if (!('options' in value) || value['options'] === undefined) return false;
    if (!('correctIndex' in value) || value['correctIndex'] === undefined) return false;
    return true;
}

export function TriviaQuestionFromJSON(json: any): TriviaQuestion {
    return TriviaQuestionFromJSONTyped(json, false);
}

export function TriviaQuestionFromJSONTyped(json: any, ignoreDiscriminator: boolean): TriviaQuestion {
    if (json == null) {
        return json;
    }
    return {
        
        'question': json['question'],
        'options': json['options'],
        'correctIndex': json['correctIndex'],
    };
}

export function TriviaQuestionToJSON(json: any): TriviaQuestion {
    return TriviaQuestionToJSONTyped(json, false);
}

export function TriviaQuestionToJSONTyped(value?: TriviaQuestion | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'question': value['question'],
        'options': value['options'],
        'correctIndex': value['correctIndex'],
    };
}

